// Mirrors the EmailDirection enum in api/src/graphql/emails.sdl.ts.
export enum EmailDirection {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
}
